
const InvalidPage = ({ PPHIRetry, orderData }) => {
    return (
        <div>
            <div className="retry-container">
                <div className="retry-card">
                    <div className="retry-cross-icon">×</div>
                    <h2 className="retry-heading">{orderData?.error_message || "Something Went Wrong"}</h2>
                    <p className="retry-message">{orderData.error_code === "790" ? "Please try again after some time." : ""}</p>
                    {orderData.error_code === "790" && <button className="pphi-button" onClick={() => PPHIRetry()}>
                        Try Again
                    </button>}
                </div>
            </div>
        </div>
    );
};

export default InvalidPage;
